export default __webpack_public_path__ + "static/media/33.2fb77f80.jpg";